import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck, RefreshCcw, Lock } from "lucide-react";
import { PRICE_LABEL } from "@/lib/markets";

const FinalCTA = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden py-28 sm:py-36" data-testid="final-cta-section">
      <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="font-display text-3xl font-extrabold leading-tight tracking-tight text-[#0a0a0a] sm:text-5xl lg:text-6xl"
        >
          Start your first month. <span className="font-accent text-grad-aurora">{PRICE_LABEL.split(" ·")[0]}.</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          <button
            data-testid="final-cta-button"
            onClick={() => navigate("/checkout")}
            className="btn-main group mx-auto mt-10 flex items-center gap-3 whitespace-nowrap rounded-full px-8 py-4 font-sub text-base font-bold uppercase tracking-wide sm:px-10 sm:py-5 sm:text-lg"
          >
            Join 50 CR Club · {PRICE_LABEL.split(" ·")[0]}
            <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" />
          </button>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-mono2 text-[11px] uppercase tracking-[0.2em] text-slate-500">
            <span className="flex items-center gap-2">
              <Lock className="h-3.5 w-3.5" /> Secure payment
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="h-3.5 w-3.5" /> 30-day access
            </span>
            <span className="flex items-center gap-2">
              <RefreshCcw className="h-3.5 w-3.5" /> Cancel anytime
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
